import * as React from 'react';
import { SVGProps } from 'react';

const SvgMybsw = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M13.916 4.972h11.663a1.943 1.943 0 0 1 1.943 1.943v27.213H13.916a1.943 1.943 0 0 1-1.943-1.943V6.916a1.943 1.943 0 0 1 1.943-1.943zm10.045 1.944h-8.428"
    />
    <path
      fill={props.fill}
      d="M28.494 35.1v-3.868l-9.734-.019-3.856 3.856 13.591.031z"
    />
    <path
      fill="currentColor"
      d="M20.244 24.063c.047 0 .093 0 .093-.066s-.043-.054-.086-.054h-.078v.121h.07zm-.07.218h-.051v-.389h.144c.093 0 .136.031.136.109.001.014-.001.027-.005.04s-.011.025-.02.035-.02.018-.032.024a.09.09 0 0 1-.039.009l.109.171h-.066l-.101-.167h-.066l-.008.167zm.07.086a.27.27 0 0 0 .251-.173.274.274 0 0 0 .017-.106.26.26 0 0 0-.073-.199c-.025-.027-.055-.048-.089-.062s-.07-.022-.106-.022c-.037 0-.073.007-.107.022s-.064.036-.09.062a.276.276 0 0 0-.075.2.261.261 0 0 0 .075.198.266.266 0 0 0 .197.081zm-.338-.28a.34.34 0 0 1 .209-.313.335.335 0 0 1 .368.074.341.341 0 0 1-.051.52.34.34 0 0 1-.501-.151.342.342 0 0 1-.025-.13zm-4.117-4.51h3.662l-1.994 1.959h-1.668v-1.959zm3.814 5.688v-5.614l-1.924 2.072v3.541h1.924zm5.87-5.688h-5.431l1.994 1.959h3.437v-1.959zm-5.582 3.88v-3.806l1.924 2.072v1.734h-1.924zm-5.874-4.136h5.435l-2.033-1.955h-3.402v1.955zm5.586-3.88v3.81l-1.924-2.072v-1.738h1.924zm4.098 3.88h-3.658l1.994-1.955h1.664v1.955zm-3.81-5.684v5.614l1.924-2.072v-3.541h-1.924z"
    />
  </svg>
);

export default SvgMybsw;
